import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { createDraftPipelineMutation } from './createDraftPipelineMutation';
import draftMutationKeys from './keyFactory';
import { applyOptimisticDeleteStage } from './optimisticUpdates';

const DELETE_PIPELINE_STAGE_MUTATION = graphql(`
  mutation DeletePipelineStage($id: ID!) {
    deletePipelineStage(id: $id)
  }
`);

type DeletePipelineStageInput = {
  stageId: string;
};

const useDraftDeletePipelineStage = createDraftPipelineMutation()({
  mutationKey: draftMutationKeys.deletePipelineStage,
  mutationFn: (input: DeletePipelineStageInput) => {
    return gqlClient.request(DELETE_PIPELINE_STAGE_MUTATION, {
      id: input.stageId,
    });
  },
  applyOptimisticUpdate: (data, variables) =>
    applyOptimisticDeleteStage(data, variables),
});

export default useDraftDeletePipelineStage;
